// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 897 ? "sentry" : chunkId) + ".legacy." + {"897":"e7e6ccabaafa7b7f0162","974":"7c665ddde0ec31ce7d78"}[chunkId] + ".js";
};